module.exports = __webpack_public_path__ + "img/3.605c0c06.jpg";